import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Contenedores, InventoryIdenty, ESTADO_CONTENEDOR, StateViewer, ShoppingCart, TypeShoppingCart } from '../../../core/model/inventories';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { UtcDatePipe } from '../../../core/pipes/utc-date-pipe';
import { InventariosService } from '../../../core/services/inventarios.service';

@Component({
  selector: 'app-container-viewer',
  templateUrl: './container-viewer.component.html',
  styleUrls: ['./container-viewer.component.css']
})
export class ContainerViewerComponent implements OnInit {

  @Input() isInventoryView: boolean;
  contenedor: Contenedores;
  @Input() set contenedorBasico(_contenedor: Contenedores) {
    if (!_contenedor.estadosViewer) {
      _contenedor.estadosViewer = this.getEstadosViewer(_contenedor.estado.toString(), _contenedor.fechaCreacion);
    }
    if (!_contenedor.fieldsToShow) {
      _contenedor.fieldsToShow = this.getFieldsToShow(_contenedor);
    }

    this.contenedor = _contenedor;
   }

  @Output() editObsPartialEvent = new EventEmitter<InventoryIdenty>();
  @Output() removeRecord = new EventEmitter<InventoryIdenty>();
  @Output() createLoanEvent = new EventEmitter<InventoryIdenty>();

  constructor(private translateService: TranslateService,
              private datePipe: DatePipe,
    private utcPipe: UtcDatePipe,
    private inventoryService: InventariosService) { }

  ngOnInit() {
    if (this.inventoryService.listInventory.find( p => p == this.contenedor.id.toString() ).length > 0) {
      const toShop = new ShoppingCart();
      toShop.type = TypeShoppingCart.LOAN;
      this.contenedor.shoppingCart = toShop;
    }
  }

  isCalledFromConsultas(): boolean {
    return this.inventoryService.isCalledFromConsultas();
  }

  returnToSolicitud() {
    this.inventoryService.returnToSolicitud();
  }

  editObsPartial() {
    this.editObsPartialEvent.emit(this.contenedor);
  }

  createLoan() {
    this.createLoanEvent.emit(this.contenedor);
  }

  remove() {
    this.removeRecord.emit(this.contenedor);
  }

  tieneObsParcial(): any {
    return this.contenedor.shoppingCart && this.contenedor.shoppingCart.obsPartial;
  }

  private getEstadosViewer(estado: string, fechaCreacion: string): StateViewer[] {
    if (!estado) {
      return null;
    }

    const enumContainer = ESTADO_CONTENEDOR;

    switch (estado) {
      case enumContainer[ESTADO_CONTENEDOR.nuevo]:
        return [this.getStateViewer(enumContainer[ESTADO_CONTENEDOR.nuevo], fechaCreacion, 'fas fa-plus', 'orange')];
      case enumContainer[ESTADO_CONTENEDOR.ubicado]:
        return [this.getStateViewer(enumContainer[ESTADO_CONTENEDOR.ubicado], fechaCreacion, 'fas fa-archive', 'green')];
      case enumContainer[ESTADO_CONTENEDOR.prestado]:
        return [this.getStateViewer(enumContainer[ESTADO_CONTENEDOR.prestado], fechaCreacion, 'fas fa-lock', 'darkblue')];
      case enumContainer[ESTADO_CONTENEDOR.expurgado]:
        return [this.getStateViewer(enumContainer[ESTADO_CONTENEDOR.expurgado], fechaCreacion, 'fas fa-times', 'red')];
     }
  }

  private getStateViewer(nombre: string, fechaCreacion: string, iconClass: string, color: string): StateViewer {
    const text = this.translateService.instant(`inventory.state.${nombre}`);
    const date = this.datePipe.transform(this.utcPipe.transform(fechaCreacion), 'dd-MM-yyyy HH:mm:ss');
    const title = `${text}: ${date}`;
    return { name: nombre, iconClass: iconClass, color: color, title: title };
  }

  private getFieldsToShow(_contenedor: Contenedores): { key: string; value: any; } [] {
    const id = this.getFieldToShow('Id:',
      _contenedor.id);

    const creationDate = this.getFieldToShow(this.translateService.instant('inventory.creationDate'),
      this.datePipe.transform(this.utcPipe.transform(_contenedor.fechaCreacion), 'dd-MM-yyyy'));

    const entryDate = this.getFieldToShow(this.translateService.instant('inventory.entryDate'),
      this.datePipe.transform(this.utcPipe.transform(_contenedor.fechaEntrada), 'dd-MM-yyyy'));

    const numContainer = this.getFieldToShow(this.translateService.instant('inventory.numContainer'),
      _contenedor.numContenedor);

    const expurgeDate = this.getFieldToShow(this.translateService.instant('inventory.expurgeDate'),
      this.datePipe.transform(this.utcPipe.transform(_contenedor.fechaExpurgo), 'dd-MM-yyyy'));

    const albaranId = this.getFieldToShow(this.translateService.instant('inventory.albaranId'),
      _contenedor.albaranId);

    const fieldsToShow: { key: string; value: any; }[] = [
      id,
      creationDate,
      entryDate,
      numContainer,
      expurgeDate,
      albaranId
    ];
    return fieldsToShow;
  }

  private getFieldToShow(text: string, value: any): { key: string; value: any; }  {
    return { key: text, value };
   }

}
